module.exports = __webpack_public_path__ + "img/room6.70c61d7a.gif";